export interface Experiments {
  enabled(key: string): boolean;
  ready(): Promise<any>;
  get(key: string): any;
}

export interface ExperimentsBag {
  [key: string]: string | boolean;
}

export function getWixPatternsWindowExperiments(): ExperimentsBag | undefined {
  return (window as any).__CAIRO_EXPERIMENTS__;
}

export function getExperimentsCompat(essentials: {
  experiments: Experiments;
}): Experiments {
  try {
    const experiments = essentials.experiments ?? experimentsFallbackApi();
    // When external users in WixCli run it we get exception and we need to use the fallback API
    experiments.enabled('dummy');

    return experiments;
  } catch (e) {
    console.error(e);
    return experimentsFallbackApi();
  }
}

export const experimentsFallbackApi = (): Experiments => ({
  enabled: () => false,
  ready: () => Promise.resolve(true),
  get: () => '',
});
